function simpleFolderList() {
}

simpleFolderList.prototype = {
	
	loadFolder: function(n) {
		if (!player.folders[n].opened) {
			$("#folder_" + n).show();
		} else $("#folder_" + n).hide();
		
		player.folders[n].opened = !player.folders[n].opened;
		
		if (player.folders[n].loaded) return;
		
		for(var i = 0; i < player.folders[n].panos.length; i ++) {
			data = player.folders[n].panos;
			elem = $("<div class='panolink'><a href='index.php?id=" + data[i].id + "'><img src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
			$("#folder_" + n).append(elem);
		}
		player.folders[n].loaded = true;
	},
	
	getCurrent: function(data) {
		return this.current;
	},
	
	loadPanoList: function(data) {		
		var current = {id:"-1", title:"Lista panoram"};
		current.panos = [];
		
		//player.current = null;
		
		if (!player.imagesLoaded) {
				
			for(var i = 0; i < data.length; i ++) {
				if (data[i].type == "folder") {
					if (current != null) {
						player.folders.push(current);
					}
					
					if (data.length > i + 1 && data[i + 1].type == "folder") {
						elem = $("<div class='folderempty'>" + data[i].title + "</div>");
					} else {
						elem = $("<div class='folder'><a href='javascript:void(null);' onclick='player.list.loadFolder(" + player.folders.length + ");'>" + data[i].title  + "</a></div><div id='folder_" + player.folders.length + "'></div>");
					}					
					$("#panos").append(elem);					
					
					current = {id:data[i].id, title:data[i].title};
					current.panos = [];
				} else {
				
					current.panos.push(data[i]);
					
					elem = $("<div class='panolink'><a href='index.php?id=" + data[i].id + "'><img src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
//					elem = $("<div class='panolink'><a href='index.php?id=" + data[i].id + "'><img src='' data-src='" + player.storage + "/thumb.php?id=" + data[i].id + "'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
					$("#panos").append(elem);
					
					if (data[i].id == player.ident) {
						currentpano = data[i];
						//current.panos = [];
					}					
				}
			}
			
			player.folders.push(current);
			
			player.imagesLoaded = true;
		}
		
		for(var i = 0; i < player.folders.length; i ++) {
//			player.loadFolder(i);
		}
		
		this.current = currentpano;
	}	
}